import { MarketingLabel } from '@@types'

import styles from './styles.module.scss'

interface ProductLabelDescriptionsProps {
  labels?: MarketingLabel[]
}

export default function ProductLabelDescriptions ({ labels }: ProductLabelDescriptionsProps) {
  const filtered = labels?.filter(l => l.description || l.optionLink)

  if (!filtered || filtered.length === 0) {
    return null
  }

  return (
    <div className={styles.root}>
      {filtered.map(label => (
        <div key={label.id} className={styles.item}>
          {label.image?.url && (
            <div className={styles['item__image-wrapper']}>
              <img
                className={styles.item__image}
                src={label.image.url}
                alt={label.title}
                loading="lazy"
              />
            </div>
          )}
          <div className={styles.item__body}>
            <h4 className={styles.item__title}>{label.title}</h4>
            {label.description && (
              <p className={styles.item__description}>{label.description}</p>
            )}
            {label.optionLink && label.optionLinkLabel && (
              <a
                className={styles.item__link}
                href={label.optionLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {label.optionLinkLabel}
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
